import { Routes, Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";

function AppRoutes() {
  return (
    <Routes>
      {/* Layout público — Header + Footer envolvem todas as páginas */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        {/* futuras rotas públicas ficam aqui:
        <Route path="/planos" element={<Planos />} />
        <Route path="/sobre"  element={<Sobre />} />
        */}
      </Route>

      {/* Fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
